import React from 'react';

import { cx } from 'helpers/StylingHelpers';
import { useFilters } from 'hooks/useFilters';
import { useMediaQuery } from 'hooks/useMediaQuery';

import FiltersDesktop from './FiltersDesktop';
import FiltersMobile from './FiltersMobile';

import type { IFilters, PageType } from 'types';

import styles from './Filters.module.scss';

interface Props {
  className?: string,
  //
  filters: { filters: IFilters | undefined, multiple?: boolean },
  //
  pageType: PageType,
  data?: { count?: number },
  //
  withLabel?: boolean,
  withAccordion?: boolean,
  withActiveFilters?: boolean,
  withClearButton?: boolean,
  inline?: boolean,
  desktopProps?: {
    classNames?: React.ComponentProps<typeof FiltersDesktop>['classNames']
  }
}

const Filters = (props: Props) => {

  const {
    className,
    //
    filters: {
      filters,
      multiple = true
    } = {},
    //
    pageType,
    data,
    //
    withLabel = true,
    withAccordion = false,
    withActiveFilters = false,
    withClearButton = true,
    inline = true,
    //
    desktopProps
  } = props;

  const { classNames: desktopClassNames = {} } = desktopProps || {};
  const { getFilterHref: getHref, clearFilter, clearFilters } = useFilters({ pageType, items: filters?.items, multiple });

  // Hooks
  const isBreakpoint = useMediaQuery(`(max-width: ${styles.breakpoint})`);

  // Props

  const { items } = filters || {};
  const hasAvailableFilters = items?.some((filter) => filter?.values?.length > 0);

  // Empty

  if (!filters || !Array.isArray(items) || !hasAvailableFilters) {
    return null;
  }

  // Render

  return (
    <div className={cx(styles.root, className)}>
      {
        isBreakpoint
          ? (
            <FiltersMobile
              filters={filters}
              data={data}
              pageType={pageType}
              //
              getHref={getHref}
              clearFilter={clearFilter}
              clearFilters={clearFilters}
            />
          ) : (
            <FiltersDesktop
              filters={filters}
              classNames={desktopClassNames}
              //
              withLabel={withLabel}
              withAccordion={withAccordion}
              withActiveFilters={withActiveFilters}
              withClearButton={withClearButton}
              inline={inline}
              multiple={multiple}
              //
              getHref={getHref}
              clearFilters={clearFilters}
            />
          )
      }
    </div>
  );
};

export default Filters;
